<template>
  <div
    class="sf-pad-h-1 sf-pad-v-1 sf-level sf-pointer sf-level sf-level-between"
    data-testid="remap-inline-item"
    @click="handleClick"
  >
    <div class="sf-level">
      <div v-tooltip="tooltip"><i class="fa fa-wand-magic-sparkles" /></div>
      <div :class="{ 'remap-inline-item--hoverable': !isCurrent }">
        {{ label }}
      </div>
    </div>

    <div>
      <i
        v-if="isCurrent"
        class="fa fa-check sf-c-primary"
        data-testid="current-remap-inline-item"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { AccountRange } from '../shared-types'
import { useCommon } from '../store/common'
import { useLocale } from '../store/locale'
import { pickGroupLeafNameByFirstAvailableLocale } from '../utils'

defineOptions({
  name: 'RemapInlineItem',
})

interface Props {
  accountRange: AccountRange
  currentAccountRange: AccountRange
}
const props = defineProps<Props>()

const emit =
  defineEmits<{
    'item-clicked': [accountRange: AccountRange]
  }>()

const commonStore = useCommon()
const localeStore = useLocale()

const tooltip = window.I18n.t('account_mapping_list.tooltip.top_alternatives')

const label = computed(
  () =>
    `${props.accountRange} ${pickGroupLeafNameByFirstAvailableLocale(
      commonStore.groups[
        commonStore.getAccountRangePerGroup[props.accountRange]
      ],
      localeStore.supportedLocales
    )}`
)

const isCurrent = computed(
  () => props.accountRange === props.currentAccountRange
)

function handleClick() {
  emit('item-clicked', props.accountRange)
}
</script>
<style lang="scss" scoped>
@import 'silverfin-ui-kit/src/scss/tooling';

.remap-inline-item {
  &--hoverable {
    &:hover {
      @include color('primary');
    }
  }
}
</style>
